import styled from 'styled-components';
import { mediaQuery } from '../../../common/styles/styleUtil';

export const OtherNearbyProjectWrapper = styled.div`
  clear: both;
  position: relative;
  max-width: 1140px;
  margin-bottom: 40px;
  padding-top: 32px;
  @media (${mediaQuery.tablet}) {
    padding-bottom: 24px;
  }
  @media (${mediaQuery.mobile}) {
    padding-top: 16px;
  }
`;

export const OtherNearbyProjectTitle = styled.h2`
  margin-bottom: 16px;
  font-size: 24px;
  font-weight: bold;
  color: #000000;
  span {
    font-size: 24px;
    text-transform: lowercase;
  }
`;

export const ProjectListCarouselWrapper = styled.div`
  margin-top: 32px;

  @media (${mediaQuery.tablet}) {
    padding-left: 20px;
  }

  @media (${mediaQuery.mobile}) {
    margin-top: 24px;
  }
`;

export const Wrapper = styled.div`
  max-width: 1140px;
  margin: 0 auto;
`;

export const TopContentWrapper = styled.div`
  width: 100%;
  padding: 0 32px 32px 0;
  background-color: #f3f4f6;
`;
